module.exports = __webpack_public_path__ + "img/team.00ab9836.png";